import { Path } from 'react-hook-form';
import { ReviewFormValues, StepKey } from './types';
import { ExperienceType } from './ReviewWizard';

export const asPath = <T extends Path<ReviewFormValues>>(p: T) => p;

export function isSchemaStep(
    k: StepKey,
): k is Exclude<StepKey, 'review' | 'submitted'> {
    return k !== 'review';
}

export const stepTitlesForType = (
    type: ExperienceType,
): Array<{ key: StepKey; title: string; subtitle?: string }> => {
    const accessTitle =
        type === ExperienceType.Vehicle
            ? 'Pickup / Return / Access'
            : type === ExperienceType.Commercial
              ? 'Access / Building Entry'
              : type === ExperienceType.Activity
                ? 'Meeting Point / Check-in'
                : 'Location / Access / Check-in';

    const steps = [
        {
            key: 'overall' as const,
            title: 'How was your experience?',
            subtitle: 'Tell us about your overall experience.',
        },
        {
            key: 'cleanliness' as const,
            title: 'Cleanliness',
            subtitle: 'How clean was it?',
        },
        {
            key: 'accuracy' as const,
            title: 'Accuracy of Listing',
            subtitle: 'Did it match the description?',
        },
        {
            key: 'communication' as const,
            title: 'Communication',
            subtitle: "How was the host's communication?",
        },
        {
            key: 'access' as const,
            title: `${accessTitle}`,
            subtitle: 'Was getting started smooth?',
        },
        {
            key: 'value' as const,
            title: 'Value / Amenities',
            subtitle: 'Was it worth the price?',
        },
        {
            key: 'details' as const,
            title: 'Write a public review',
            subtitle: 'We will show this review to other guests. ',
        },
        {
            key: 'review' as const,
            title: 'Review & Submit',
            subtitle: 'Confirm your answers',
        },
        {
            key: 'submitted' as const,
            title: 'Review Submitted',
            subtitle:
                'We appreciate you taking the time to share your feedback. Your review will be published in 7 days and, once published, it cannot be edited.',
        },
    ];

    return type === ExperienceType.Activity
        ? steps.filter((s) => s.key !== 'cleanliness')
        : steps;
};

export const transformExistingReviewToFormData = (
    review: any,
): Partial<ReviewFormValues> => {
    if (!review) return {};

    return {
        rating: review.rating || 0,
        reviewText: review.reviewText || '',
        photos: review.photos || [],
        isAnonymous: Boolean(review.isAnonymous),
        cleanliness: review.cleanliness,
        accuracy: review.accuracy,
        communication: review.communication,
        access: review.access,
        value: review.value,
    };
};
